<div class="col-sm-12" style="height: 100%; padding-top: 5px;">
  <div class="fiche">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-6 fiche-client">
        <div *ngIf="!add" class="numchantier"> {{ agence.nom }} {{ agence.prenom || '' }} </div>
        <div *ngIf="add"> Création Agence </div>
      </div>
      <button class="uppercase" *ngIf="edit && !add" id="savecont" (click)="saveAgence()"> Enregistrer </button>
      <button class="uppercase" *ngIf="add" id="addcont" (click)="saveAgence()"> Valider </button>
      <button class="uppercase" *ngIf="!edit" id="editcont" (click)="editAgence()">Modifier </button>
      <button class="uppercase btn-close" id="closecont" (click)="showFiche()"> Fermer </button>
    </div>

    <div class="col-sm-12" style="padding-right: 0;" [ngStyle]="{'padding-top': '5px'}">
      <div class="input-group col-sm-12 recherche">
        <input type="text" id="ficheinput2" class="form-control" placeholder="Rechercher une donnée agence"
          [(ngModel)]="searchCritere" (keyup.enter)="filtreSearch($event)" (ngModelChange)="changeRecherche()" />
        <div class="input-group-addon">
          <img src="assets/images/icons/search.svg" class="pull-right" alt="search" />
        </div>
      </div>
    </div>
  </div>
  <div class="contente" *ngIf="!isEmpty">
    <div class="info-client cht col-sm-12 pull-right">
      <div class="col-sm-12" *ngIf="isRecherche"
        style="background-color: #dbe8f8; padding: 5px 20px; letter-spacing: 2px;">
        Résultat de la recherche </div>
      <div class="col-sm-12 searchblock" *ngIf="!viaFicheClt || isRecherche">
        <div *ngIf="add" style="font-size: 10px;"> ( <span style="color:red;">*</span> ) : Champs obligatoires </div>
        <div class="group1">
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Nom :
              <span class="champobligatoire" style="color:red;" *ngIf="add"> * </span>
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ agence.nom || ''}}</div>
              <input *ngIf="edit" type="text" class="form-control" id="nomagence" autofocus [(ngModel)]="agence.nom">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              Adresse
              <span class="champobligatoire" style="color:red;" *ngIf="add"> * </span>
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ agence.adresse1 }}</div>
              <div *ngIf="!edit">{{ agence.adresse2 }}</div>
              <div *ngIf="!edit">{{ agence.adresse3 }}</div>
              <div *ngIf="edit">
                <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'"
                  (searchfunction)="searchAdresseBAK($event)" (selectfunction)="setValueAdresseBAK($event)"
                  [results]="dataAdresseBAK" [container]="true" [defaultsearch]="agence.adresse1 ? agence.adresse1 : ''"
                  [minlength]="3" [nePasCompterEspace]="true">
                </app-autocomplete>
                <input *ngIf="edit && common.visibleChamp.clt16 && !adresseAutoBAK" type="text" class="form-control"
                  [(ngModel)]="agence.adresse1" [readonly]="adresseAutoBAK">
              </div>
              <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse1"-->
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse2"
                style="margin-top: 5px; margin-bottom: 5px;" [readonly]="adresseAutoBAK">
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse3"
                [readonly]="adresseAutoBAK">
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              CP :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{agence.cp}} </div>
              <div *ngIf="edit">
                <app-autocomplete-cp-ville [cp]="'cp'" [item]="agence" [ville]="'ville'" [iscp]="true"
                  [disable]="adresseAutoBAK"></app-autocomplete-cp-ville>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px">
              Ville :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{agence.ville}} </div>
              <div *ngIf="edit">
                <app-autocomplete-cp-ville [cp]="'cp'" [item]="agence" [ville]="'ville'" [disable]="adresseAutoBAK">
                </app-autocomplete-cp-ville>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12" *ngIf="adresseAutoBAK">
            <label class="col-sm-3 champ" style="padding:0px">
              Ancienne Ville :
            </label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit"> {{common.bak.ancienneVille}} </div>
              <div *ngIf="edit">
                <app-autocomplete-cp-ville [item]="common.bak" [ville]="'ancienneVille'" [disable]="adresseAutoBAK">
                </app-autocomplete-cp-ville>
              </div>
            </div>
          </div>
          <div class="form-group items col-sm-12">
            <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ agence.mail }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.mail"
                (keydown)="common.filterCarracterEmail($event)">
            </div>
          </div>
          <div class="form-group items col-sm-12" *ngIf="common.IsFactElectronique">
            <label class="col-sm-3 champ" style="padding:0px"> Adresse fact électronique :</label>
            <div class="col-sm-9 champ" style="padding-right: 0px">
              <div *ngIf="!edit">{{ agence.adresseFacturationElectronique }}</div>
              <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresseFacturationElectronique"
                (keydown)="common.filterCarracterEmail($event)">
            </div>
          </div>
        </div>
      </div>

      <ngb-tabset [justify]="'fill'" *ngIf="viaFicheClt && !isRecherche">
        <ngb-tab title="Général">
          <ng-template ngbTabContent>
            <div *ngIf="add" style="font-size: 10px;"> ( <span style="color:red;">*</span> ) : Champs obligatoires
            </div>
            <div class="group1">
              <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px"> Nom :
                  <span class="champobligatoire" style="color:red;" *ngIf="add"> * </span>
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit">{{ agence.nom || ''}}</div>
                  <input *ngIf="edit" type="text" class="form-control" id="nomagence" autofocus
                    [(ngModel)]="agence.nom">
                </div>
              </div>
              <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                  Adresse
                  <span class="champobligatoire" style="color:red;" *ngIf="add"> * </span>
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit">{{ agence.adresse1 }}</div>
                  <div *ngIf="!edit">{{ agence.adresse2 }}</div>
                  <div *ngIf="!edit">{{ agence.adresse3 }}</div>
                  <div *ngIf="edit">
                    <app-autocomplete *ngIf="adresseAutoBAK" [placeholder]="'Adresse'"
                      (searchfunction)="searchAdresseBAK($event)" (selectfunction)="setValueAdresseBAK($event)"
                      [results]="dataAdresseBAK" [container]="true"
                      [defaultsearch]="agence.adresse1 ? agence.adresse1 : ''" [minlength]="3"
                      [nePasCompterEspace]="true">
                    </app-autocomplete>
                    <input *ngIf="edit && common.visibleChamp.clt16 && !adresseAutoBAK" type="text" class="form-control"
                      [(ngModel)]="agence.adresse1" [readonly]="adresseAutoBAK">
                  </div>
                  <!--input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse1"-->
                  <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse2"
                    style="margin-top: 5px; margin-bottom: 5px;" [readonly]="adresseAutoBAK">
                  <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.adresse3"
                    [readonly]="adresseAutoBAK">
                </div>
              </div>
              <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                  CP :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit"> {{agence.cp}} </div>
                  <div *ngIf="edit">
                    <app-autocomplete-cp-ville [cp]="'cp'" [item]="agence" [ville]="'ville'" [iscp]="true"
                      [disable]="adresseAutoBAK"></app-autocomplete-cp-ville>
                  </div>
                </div>
              </div>
              <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px">
                  Ville :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit"> {{agence.ville}} </div>
                  <div *ngIf="edit">
                    <app-autocomplete-cp-ville [cp]="'cp'" [item]="agence" [ville]="'ville'" [disable]="adresseAutoBAK">
                    </app-autocomplete-cp-ville>
                  </div>
                </div>
              </div>
              <div class="form-group items col-sm-12" *ngIf="adresseAutoBAK">
                <label class="col-sm-3 champ" style="padding:0px">
                  Ancienne Ville :
                </label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit"> {{common.bak.ancienneVille}} </div>
                  <div *ngIf="edit">
                    <app-autocomplete-cp-ville [item]="common.bak" [ville]="'ancienneVille'" [disable]="adresseAutoBAK">
                    </app-autocomplete-cp-ville>
                  </div>
                </div>
              </div>
              <div class="form-group items col-sm-12">
                <label class="col-sm-3 champ" style="padding:0px"> Mail :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit">{{ agence.mail }}</div>
                  <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="agence.mail"
                    (keydown)="common.filterCarracterEmail($event)">
                </div>
              </div>
              <div class="form-group items col-sm-12" *ngIf="common.IsFactElectronique">
                <label class="col-sm-3 champ" style="padding:0px"> Adresse fact électronique :</label>
                <div class="col-sm-9 champ" style="padding-right: 0px">
                  <div *ngIf="!edit">{{ agence.adresseFacturationElectronique }}</div>
                  <input *ngIf="edit" type="text" class="form-control"
                    [(ngModel)]="agence.adresseFacturationElectronique" (keydown)="common.filterCarracterEmail($event)">
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-tab>
        <ngb-tab>
          <ng-template ngbTabTitle>
            <div (click)="detectScroll();"> CHANTIERS</div>
          </ng-template>
          <ng-template ngbTabContent>
            <div class="col-sm-12" id="tableDocEcoportail" style="max-height: calc(100% - 60px); overflow: hidden;"
              [ngStyle]="{'height': hasScroll ? 'calc(100% - 60px)' : 'auto'}">
              <ngx-datatable class="material" [rows]="listeChantier || []" style="height: 100%;" [columnMode]="'force'"
                [headerHeight]="30" [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'single'"
                [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de chantier à afficher'}"
                [loadingIndicator]="loadingIndicator">

                <ngx-datatable-column prop="numChantier">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> N Chantier </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                    <div *ngIf="row.edit && !row.id">
                      <app-autocomplete [placeholder]="'Rechercher un chantier'"
                        (searchfunction)="searchChantier($event)"
                        (selectfunction)="getDetailChantier($event, row, 'true')" [results]="listeChantierRecherche"
                        [highlight]="true" [disablefocus]="true" [label]="''" [defaultselected]="row" [container]="true"
                        [defaultsearch]="row ? row.numChantier : ''" [showResultKeyenter]="true"
                        [autohide]="true"></app-autocomplete>
                    </div>
                    <div *ngIf="!row.edit || row.id"> {{ value || '' }} </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="ville">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Ville </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div> {{ value || '' }} </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="50">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                    <!--button *ngIf="row.edit" class="btn-detail" (click)="saveChantierAgence(row)">
                      <i class="fa fa-pencil"></i>
                    </button-->
                    <button class="btn-detail" (click)="deleteLigne(row)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
            <div class="col-sm-12">
              <div class="col-sm-5" style="padding: 5px;">
                <button class="btn-add" (click)="addLigne()">
                  <i class="fa fa-plus"></i>
                </button>
                <span (click)="addLigne()"> Ajouter un chantier </span>
              </div>
            </div>
          </ng-template>
        </ngb-tab>
      </ngb-tabset>
    </div>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>